var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
import React from 'react';
export var SafetyNetProviderContext = React.createContext({});
var SAFETY_NET_COOKIE_NAME = 'safetynet';
export var SafetyNetProvider = function (_a) {
    var children = _a.children, openChat = _a.openChat;
    // chat window not open
    if (!openChat)
        return React.createElement(React.Fragment, null);
    if (Cookies.get(SAFETY_NET_COOKIE_NAME) === 'true') {
        var pathname = window.location.pathname;
        var returnURL = "".concat(pathname, "?openChatWindow=1");
        var encodeURI_1 = encodeURIComponent(returnURL);
        window.location.assign("/safety-net?returnURL=".concat(encodeURI_1));
        return null;
    }
    return React.createElement(SafetyNetProviderContext.Provider, { value: {} }, children);
};
export var withSafetyNetProvider = function (Component) {
    return function (props) {
        return (React.createElement(SafetyNetProvider, { openChat: props.openChat },
            React.createElement(Component, __assign({}, props))));
    };
};
//# sourceMappingURL=index.js.map